<div class="empty-snapshot__teaser">
  <div class="empty-snapshot__teaser__illustration spacing-down--base">
    <p1-lib-icons-icon-wrapper name="illustrationEmptyWatchlistSnapshot"></p1-lib-icons-icon-wrapper>
  </div>
  <div class="empty-snapshot__teaser__content spacing-down--base">
    <h1 i18n="headline // page: watchlist snapshot empty @@empty-watchlist-snapshot-teaser.component_headline">
      Nothing to see here
    </h1>
    <p i18n="description // page: watchlist snapshot empty @@empty-watchlist-snapshot-teaser.component_description">
      This watchlist does not contain any elements or sublists.
    </p>
  </div>
</div>
